import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { ApiRequestError } from '../lib/api';
import { Button, Card, PageLoader } from '../components/ui';

/**
 * Вход по ссылке из кабинета: ученик открывает адрес и сразу оказывается
 * внутри, без логина и пароля. Токен обменивается на сессию один раз при
 * открытии страницы, дальше работает обычная авторизация.
 */
export function EnterByLinkPage(): React.JSX.Element {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { loginByLink } = useAuth();
  const [error, setError] = useState<string | null>(null);

  // React в строгом режиме монтирует страницу дважды. Без этого флага токен
  // обменивался бы на сессию два раза подряд и счётчик переходов врал бы.
  const isStarted = useRef(false);

  useEffect(() => {
    if (!token || isStarted.current) return;
    isStarted.current = true;

    loginByLink(token)
      .then(() => navigate('/schedule', { replace: true }))
      .catch((caught: unknown) => {
        setError(
          caught instanceof ApiRequestError
            ? caught.message
            : 'Не удалось войти по ссылке. Проверьте интернет и попробуйте ещё раз.',
        );
      });
  }, [token, loginByLink, navigate]);

  if (!error) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <PageLoader />
      </div>
    );
  }

  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <Card className="w-full max-w-sm text-center">
        <h1 className="text-lg font-semibold">Ссылка не сработала</h1>
        <p className="mt-2 text-sm text-muted">{error}</p>
        <p className="mt-4 text-sm text-muted">
          Попросите инструктора прислать новую или войдите по телефону и паролю.
        </p>
        <Link to="/login" className="mt-5 block">
          <Button fullWidth>Войти по паролю</Button>
        </Link>
      </Card>
    </div>
  );
}
